// Copyright 2021 The Casdoor Authors. All Rights Reserved.
//
// Licensed under the Apache License, Version 2.0 (the "License");
// you may not use this file except in compliance with the License.
// You may obtain a copy of the License at
//
//      http://www.apache.org/licenses/LICENSE-2.0
//
// Unless required by applicable law or agreed to in writing, software
// distributed under the License is distributed on an "AS IS" BASIS,
// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
// See the License for the specific language governing permissions and
// limitations under the License.

import React from "react";
import {Alert, Button, Result, message} from "antd";
import i18next from "i18next";

export function showMessage(type, text) {
  if (type === "success") {
    message.success(text);
  } else if (type === "error") {
    message.error(text);
  }
}

export function renderMessage(msg) {
  if (msg !== null) {
    return (
      <div style={{display: "inline"}}>
        <Alert
          message="Login Error"
          showIcon
          description={msg}
          type="error"
          action={
            <Button size="small" danger>
              Detail
            </Button>
          }
        />
      </div>
    );
  } else {
    return null;
  }
}

export function renderMessageLarge(ths, msg, handleBack) {
  if (msg !== null) {
    return (
      <div style={{display: "inline"}}>
        <Result
          status="error"
          title={i18next.t("account:There was a problem signing you in")}
          subTitle={msg}
          extra={[
            <Button type="primary" key="back" onClick={() => {
              handleBack && handleBack();
            }}>
              {i18next.t("general:Back")}
            </Button>,
            // <Button key="home" onClick={() => Setting.goToLinkSoft(ths, "/")}>
            //   Home
            // </Button>,
            // <Button type="primary" key="signup" onClick={() => Setting.goToLinkSoft(ths, "/signup")}>
            //   Sign Up
            // </Button>,
          ]}
        >
        </Result>
      </div>
    );
  } else {
    return null;
  }
}

function getRefinedValue(value) {
  return (value === null) ? "" : value;
}

export function getCasParameters(params) {
  const queries = (params !== undefined) ? params : new URLSearchParams(window.location.search);
  const service = getRefinedValue(queries.get("service"));
  const renew = getRefinedValue(queries.get("renew"));
  const gateway = getRefinedValue(queries.get("gateway"));
  return {
    service: service,
    renew: renew,
    gateway: gateway,
  };
}

export function getOAuthGetParameters(params) {
  const queries = (params !== undefined) ? params : new URLSearchParams(window.location.search);
  const clientId = getRefinedValue(queries.get("client_id"));
  const responseType = getRefinedValue(queries.get("response_type"));
  const redirectUri = getRefinedValue(queries.get("redirect_uri"));
  const scope = getRefinedValue(queries.get("scope"));
  const state = getRefinedValue(queries.get("state"));
  const nonce = getRefinedValue(queries.get("nonce"));
  const challengeMethod = getRefinedValue(queries.get("code_challenge_method"));
  const codeChallenge = getRefinedValue(queries.get("code_challenge"));
  const samlRequest = getRefinedValue(queries.get("SAMLRequest"));
  const relayState = getRefinedValue(queries.get("RelayState"));
  const noRedirect = getRefinedValue(queries.get("noRedirect"));

  if ((clientId === undefined || clientId === null || clientId === "") && (samlRequest === "" || samlRequest === undefined)) {
    // login
    return null;
  } else {
    // code
    return {
      clientId: clientId,
      responseType: responseType,
      redirectUri: redirectUri,
      scope: scope,
      state: state,
      nonce: nonce,
      challengeMethod: challengeMethod,
      codeChallenge: codeChallenge,
      samlRequest: samlRequest,
      relayState: relayState,
      noRedirect: noRedirect,
    };
  }
}

export function getStateFromQueryParams(applicationId, providerId, method, isShortState) {
  let query = window.location.search;
  query = `${query}&application=${applicationId}&provider=${providerId}&method=${method}`;
  if (method === "link") {
    query = `${query}&from=${window.location.pathname}`;
  }

  if (!isShortState) {
    return btoa(query);
  } else {
    const state = providerId;
    sessionStorage.setItem(state, query);
    return state;
  }
}

export function getStateFromQueryParamsForWechat(queryStr, applicationId, providerId, method, isShortState, provderType) {
  let query = `${queryStr}&application=${applicationId}&provider=${providerId}&method=${method}&providertype=${provderType}`;
  if (method === "link") {
    query = `${query}&from=${window.location.pathname}`;
  }

  if (!isShortState) {
    return btoa(query);
  } else {
    const state = providerId;
    sessionStorage.setItem(state, query);
    return state;
  }
}

export function getQueryParamsFromState(state) {
  const query = sessionStorage.getItem(state);
  if (query === null) {
    return atob(state);
  } else {
    return query;
  }
}

export function encodeUrl(url) {
  if (url) {
    return btoa(encodeURIComponent(url));
  }
  return null;
}

export function decodeUrl(data) {
  if (data) {
    return decodeURIComponent(atob(data));
  }
  return "";
}

export function sleep(time) {
  return new Promise((resolve) => {
    setTimeout(resolve, time);
  });
}

export function getRndInteger(min, max) {
  return Math.floor(Math.random() * (max - min)) + min;
}

export async function wait(delay) {
  await sleep(delay);
}

/*
   * 通用性：通用
   * 方法说明：动态生成表单提交
   * 参数说明：url：提交地址；obj：需要提交的参数；target：页面如何呈现；method：表单提交方式
   */
export function openPostWindow(url, obj, target, method) {
  const tempForm = document.createElement("form");
  // if (obj.csrfmiddlewaretoken == undefined) {
  //     obj.csrfmiddlewaretoken = $.cookie("csrftoken")
  // }
  tempForm.id = "tempForm1";
  tempForm.method = method === undefined ? "get" : method;
  tempForm.action = url;
  tempForm.target = target === undefined ? "_self" : target; // 打开新页面
  for (const i in obj) {
    const hideInput = document.createElement("input");
    hideInput.type = "hidden";
    hideInput.name = i; // 后台要接收这个参数来取值
    hideInput.value = obj[i]; // 后台实际取到的值
    tempForm.appendChild(hideInput);
  }
  if (document.all) {
    tempForm.attachEvent("onsubmit", function() {}); // IE
  } else {
    // eslint-disable-next-line unused-imports/no-unused-vars
    const subObj = tempForm.addEventListener("submit", function() {}, false); // firefox
  }
  document.body.appendChild(tempForm);
  if (document.all) {
    tempForm.fireEvent("onsubmit");
  } else {
    const evt = document.createEvent("HTMLEvents");
    evt.initEvent("submit", false, false);
    tempForm.dispatchEvent(evt);
  }
  tempForm.submit();
  document.body.removeChild(tempForm);
}
